export enum AbsenceFilteringOptionsEnum {
    ALL="Wszyscy",
    HOLIDAY = 'Urlop',
    REMOTE = 'Zdalnie',
    SICK_LEAVE = 'L4'
}